// custom css for modal
export const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90vw",
    sm: 400,
  },
  maxHeight: "90vh",
  bgcolor: "background.paper",
  border: "0px solid #000",
  boxShadow: 24,
  p: {
    xs: 2,
    sm: 4,
  },
  overflowY: "auto",
  borderRadius: 2,
};
